import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { transformForm } from '@/forms/state/state';
import actions, { datasetCatalogueSteps, datasetDictionariesStep, datasetStartStep } from '../constants';
import {
  assignEditProps,
  datasetSourceAndStepAttributes,
  datasetStepsIncludes,
  resetDataset,
  switchOffDatasetPreview,
} from './state';
import findDataset from './shared';
import { transformDictionaries } from '../dictionaries/state/state';

const finishDatasetWizard = withDraft((draft, action) => {
  const item = findDataset(draft, action);
  resetDataset(item);
  switchOffDatasetPreview(item);
  item.steps = datasetSourceAndStepAttributes({ code: item.code });
});

const toggleDatasetWizard = withDraft((draft, action) => {
  const item = findDataset(draft, action);
  const { wizardOn } = item.steps;

  assignEditProps(item, action.template);
  item.steps.wizardOn = !wizardOn;
  if (item.isNew) {
    draft.wizardOff = wizardOn;
  }
});

const updateDatasetStep = withDraft((draft, action) => {
  const item = findDataset(draft, action);

  if (item.steps.activeStepIndex > action.step) {
    item.saveStatus = states.NONE;
    item.saveErrors = [];
  }
  if (datasetStepsIncludes(datasetStartStep, action.step)) {
    item.catalogue = transformForm(item.catalogue);
    item.dictionaries = transformDictionaries(item.dictionaries);
    item.copy = {};
    item.isEditing = false;
    switchOffDatasetPreview(item);
  } else if (
    datasetStepsIncludes(datasetCatalogueSteps, action.step)
    && !item.isEditing
    && action.template.readStatus === states.SUCCESS
    && assignEditProps(item, action.template, item.isNew)
  ) {
    item.isDirty.catalogue = true;
  } else if (datasetStepsIncludes(datasetDictionariesStep, action.step) && !item.isEditing) {
    assignEditProps(item, action.template);
  }
  item.steps.templateCode = null;
  item.steps.activeStepIndex = action.step;
});

export default {
  [actions.FINISH_DATASET_WIZARD]: finishDatasetWizard,
  [actions.TOGGLE_DATASET_WIZARD]: toggleDatasetWizard,
  [actions.UPDATE_DATASET_STEP]: updateDatasetStep,
};
